import { domainCodeAtom, useSaladBar } from '@australiangreens/ag-internal-components';
import { useAuth0 } from '@auth0/auth0-react';
import { useMutation } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { createList, createListAdv } from '@/apis/lists';
import { microfrontendURLPrefix } from '@/config';
import { useFeatureToggle } from '@/featureToggles/FeatureTogglesContext';
import { QFilter } from '@/types';
import { ExtendedSearchTreeNode, SearchTreeNode } from '@/types/searchTreeTypes';

export const useSaveList = (
  handleClose: () => void,
  allowNextNavigation?: () => void
) => {
  const { getAccessTokenSilently } = useAuth0();
  const domainCode = useAtomValue(domainCodeAtom);
  const { enqueueSuccessNotification } = useSaladBar();
  const navigate = useNavigate();
  const printTime = useFeatureToggle('Print Advanced Search Time');
  const useAdvancedSearchII = useFeatureToggle('Use Advanced Search II');

  return useMutation({
    mutationFn: async (
      params: { name: string; contactIds?: number[]; campaignId: number | null } & (
        | { tree: ExtendedSearchTreeNode }
        | { qFilter: QFilter }
      )
    ) =>
      Object.keys(params).includes('tree')
        ? createListAdv(
            await getAccessTokenSilently(),
            {
              name: params.name,
              tree: (params as { tree: SearchTreeNode }).tree,
              contactIds: params.contactIds,
              domainCode,
              campaignId: params.campaignId,
            },
            printTime,
            useAdvancedSearchII
          )
        : createList(await getAccessTokenSilently(), {
            ...params,
            contactIds: params.contactIds,
            domainCode,
          }),
    onSuccess: (returnedList) => {
      enqueueSuccessNotification('The list has been saved.');
      allowNextNavigation?.();
      const resultingListId = returnedList.id;
      navigate(`${microfrontendURLPrefix}/newlists/${resultingListId}`);
      handleClose();
    },
  });
};
